import { Outlet } from "react-router";

const RotaManagementComponentIndex = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default RotaManagementComponentIndex;
